import { JSX } from 'preact';

interface BooleanFacetProps {
  label: string;
  checked: boolean;
  onToggle: () => void;
  title?: string;
  icon?: JSX.Element;
  count?: number;
  showCount?: boolean;
  disabled?: boolean;
}

export function BooleanFacet({
  label,
  checked,
  onToggle,
  title,
  icon,
  count,
  showCount,
  disabled,
}: BooleanFacetProps) {
  return (
    <div className={`facet-node ${disabled ? 'disabled' : ''}`}>
      <div className={`facet-node-content ${checked ? 'active' : ''}`}>
        <button
          className="facet-toggle"
          onClick={(e) => {
            e.preventDefault();
            if (!disabled) {
              onToggle();
            }
          }}
          title={
            title || (checked ? `Deseleziona ${label}` : `Mostra solo ${label}`)
          }
          disabled={disabled}
        >
          <span className="facet-value">
            {icon && <span className="facet-icon">{icon}</span>}
            <span>{label}</span>
          </span>
          {showCount && count !== undefined && (
            <span className="facet-count">{`${count}`}</span>
          )}
          <input
            type="checkbox"
            checked={checked}
            readOnly
            style={{ marginLeft: 8 }}
          />
        </button>
      </div>
    </div>
  );
}
